import AI from "../assets/work/AI.png";
import DB from "../assets/work/db.png";
import Med from "../assets/work/med.png";
import Net from "../assets/work/netspider.png";
import PAT from "../assets/work/PAT.png";
import PokeBlue from "../assets/work/PokeBlue.png";
import TM from "../assets/work/tm.png";
import medeye from "../assets/work/medeye.png";
import vox from "../assets/work/voxIntellect.jpeg";
import TrafficGuard from "../assets/work/trafficguard.png";
import ArchiveMed from "../assets/work/arqMed.png";

// Flat, in reading order (first half fills column one top-to-bottom, second
// half fills column two). The desktop grid replays this order into two
// columns via CSS `grid-auto-flow: column` with PROJECT_GRID_ROWS rows, and
// the mobile layout scrolls it horizontally as a single row — see
// components/projects/Projects.js.
export const projects = [
  {
    href: "https://github.com/PauloDrefahl/NetspiderHSI",
    title: "Netspider HSI",
    category: "Desktop Application",
    description:
      "Software developed during my senior internship at HSI to combat human trafficking; awarded Best Internship Project at EagleX 2024.",
    technologies:
      "Python, JavaScript, Selenium, Express, React, Java, Tailwind, MongoDB",
    image: Net,
  },
  {
    href: "https://github.com/PauloDrefahl/medEyeAI",
    title: "medEyeAI",
    category: "AI / Healthcare",
    description: "AI-driven medical image analysis and enhancement project.",
    technologies: "Python, TensorFlow",
    image: medeye,
  },
  {
    href: "https://github.com/PauloDrefahl/VoxIntellect",
    title: "VoxIntellect",
    category: "Voice AI Assistant",
    description:
      "Voice-based AI assistant that transcribes speech (Whisper), generates responses (LLaMA), and outputs speech (Coqui TTS).",
    technologies: "Python, Whisper, LLaMA, Coqui TTS",
    image: vox,
  },
  {
    href: "https://github.com/PauloDrefahl/medical-clinic-fullstack-app",
    title: "Medical Clinic Fullstack App",
    category: "Full Stack Application",
    description:
      "Patient management system built for a medical clinic; hosted on AWS.",
    technologies: "HTML, CSS, JavaScript, AWS (EC2, S3, Lambda)",
    image: Med,
  },
  {
    href: "https://github.com/PauloDrefahl/multi-language-identifier-NLP",
    title: "AI Language Comparison",
    category: "AI / NLP Model Evaluation",
    description:
      "Comparative analysis of RoBERTa, BERT, and DistilBERT for multilingual text identification and performance evaluation.",
    technologies: "Python, NLP, TensorFlow, PyTorch, HuggingFace",
    image: AI,
  },
  {
    href: "https://github.com/PauloDrefahl/PokemonBlueCppVersion",
    title: "Pokemon Blue C++ Version",
    category: "Game Development",
    description:
      "A battle game inspired by Pokemon Blue, built from scratch in C++ using SFML.",
    technologies: "C++, SFML",
    image: PokeBlue,
  },
  {
    href: "https://github.com/PauloDrefahl/PAT",
    title: "PAT (Patent AI Technology)",
    category: "Full Stack Application",
    description:
      "Assists attorneys in patent analysis using Large Language Models; won 2nd place at Eagle Hacks 2024.",
    technologies: "React, JavaScript, Python, Flask, C++, LLMs, REST APIs",
    image: PAT,
  },
  {
    href: "https://github.com/PauloDrefahl/TrafficGuard-Ai",
    title: "TrafficGuard.AI (FGCU)",
    category: "Network Security / Cybersecurity",
    description:
      "Real-time network traffic monitoring and anomaly detection using GAN-based models deployed across edge servers; research published at HCI International Conference and IEEE.",
    technologies:
      "React, TypeScript, Python, PyTorch, Networks, IoT, Cybersecurity",
    image: TrafficGuard,
  },
  {
    href: "https://github.com/PauloDrefahl/Archive-Med",
    title: "Archive Med",
    category: "Mobile App / Medical Data Archiving",
    description:
      "Secure mobile app for archiving and retrieving medical records.",
    technologies: "Mobile Development, React, Node.js, MongoDB, AWS",
    image: ArchiveMed,
  },
  {
    href: "https://github.com/PauloDrefahl/Internship-Database-Portal-FGCU",
    title: "Internship Database Portal FGCU",
    category: "Databases",
    description:
      "Platform for managing internship opportunities reported by FGCU students.",
    technologies: "Python, PyQt5, MongoDB",
    image: DB,
  },
  {
    href: "https://github.com/PauloDrefahl/transfermarkt-testing-automation-tool",
    title: "Transfermarkt Testing Automation",
    category: "Testing Tool",
    description:
      "Selenium-based tool for automated testing and data validation on the Transfermarkt website.",
    technologies: "Java, Selenium",
    image: TM,
  },
];

// Rows per column for the desktop grid-auto-flow layout — keeps column one
// filling first, same as the previous hand-split two-column arrangement.
export const PROJECT_GRID_ROWS = Math.ceil(projects.length / 2);
